enum EcommerceCardFieldEnum {
    NAME = "name",
    SKU = "sku",
    MSRP = "msrp",
    PRICE = "price",
    SHORT_DESCRIPTION = "shortDescription",
    LONG_DESCRIPTION = "longDescription",
    CATEGORY = "category",
    // The purchase-controls block (qty input, UOM selector, item options, Add To Cart);
    // orderable as a single unit, never hideable
    ACTIONS = "actions",
}

export default EcommerceCardFieldEnum;
